function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.773 7.896l3.26-3.248L9.276 1.672l3 13.697 2.91-2.902c.158.147.33.309.513.493 1.61 1.61 4.224 4.8 3.636 8.063-.448 2.48-2.679 4.654-6.632 6.459a.766.766 0 00.526 1.431c1.934-.545 8.38-2.754 10.148-8.264 1.181-3.681-.053-7.974-3.605-12.753z",
  fill: "currentColor"
})));